import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SparksComponent } from './sparks.component';

@NgModule({
    declarations: [SparksComponent],
    imports: [CommonModule],
    exports: [SparksComponent],
    entryComponents: [SparksComponent],
})
export class SparksModule {}
